import { motion } from 'framer-motion';

export default function MemeHero() {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-amber-400 via-orange-400 to-rose-400 pt-24 pb-16">
      {/* Animated background blobs */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-20 -left-20 w-96 h-96 bg-yellow-300/30 rounded-full blur-3xl animate-pulse" />
        <div className="absolute -bottom-20 -right-20 w-96 h-96 bg-rose-300/30 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-orange-200/20 rounded-full blur-2xl" />
      </div>

      {/* Floating emoji decorations */}
      {['😹', '🐾', '😻', '🐱', '😂', '🔥', '💀', '😾'].map((emoji, i) => (
        <motion.span
          key={i}
          className="absolute text-3xl select-none pointer-events-none"
          style={{
            top: `${10 + (i * 11) % 80}%`,
            left: `${5 + (i * 13) % 90}%`,
          }}
          animate={{ y: [0, -12, 0], rotate: [0, i % 2 === 0 ? 10 : -10, 0] }}
          transition={{ duration: 3 + i * 0.4, repeat: Infinity, ease: 'easeInOut' }}
        >
          {emoji}
        </motion.span>
      ))}

      <div className="relative max-w-4xl mx-auto px-4 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <span className="inline-block bg-white/20 backdrop-blur-sm text-white text-sm font-bold px-4 py-1.5 rounded-full mb-4 tracking-wide uppercase">
            🔥 Updated Every Week
          </span>
          <h1 className="text-5xl md:text-7xl font-black text-white mb-4 leading-tight drop-shadow-lg">
            Cat Memes
          </h1>
          <p className="text-white/90 text-lg md:text-xl font-medium max-w-xl mx-auto mb-8">
            The internet's freshest, funniest cat memes — curated weekly and ready to share with the world 🐾
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <div className="flex items-center gap-2 bg-white/20 backdrop-blur-sm text-white px-5 py-2.5 rounded-full text-sm font-semibold">
              <i className="ri-image-2-line text-base"></i>
              New memes every Monday
            </div>
            <div className="flex items-center gap-2 bg-white/20 backdrop-blur-sm text-white px-5 py-2.5 rounded-full text-sm font-semibold">
              <i className="ri-share-line text-base"></i>
              One-click sharing
            </div>
            <div className="flex items-center gap-2 bg-white/20 backdrop-blur-sm text-white px-5 py-2.5 rounded-full text-sm font-semibold">
              <i className="ri-heart-line text-base"></i>
              Like your favorites
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
